import {
    type BannerDisplaySizeEnum,
    type BannerPrivacyEnum,
    type TopBanner,
    type TopBannerCloseActionEnum,
} from '@clients/ContentApi';
import { type ContentImage } from '@store/content/entities/types';
import { toAbsoluteSrc } from '@store/content';

interface TopBannerData extends TopBanner {
    imageAlt?: string;
}

export default class SiteTopBanner {
    constructor(data: TopBannerData) {
        this.id = data.id;
        this.privacy = data.privacy;
        this.whiteLabel = data.whiteLabel;
        this.displaySize = data.displaySize;
        this.desktopImage = data.desktopImage?.url
            ? {
                  src: toAbsoluteSrc(data.desktopImage.url),
                  blurHash: data.desktopImage.blurhash,
                  width: data.desktopImage.width,
                  height: data.desktopImage.height,
                  alt: data.imageAlt,
              }
            : undefined;
        this.mobileImage = data.mobileImage?.url
            ? {
                  src: toAbsoluteSrc(data.mobileImage.url),
                  blurHash: data.mobileImage.blurhash,
                  width: data.mobileImage.width,
                  height: data.mobileImage.height,
                  alt: data.imageAlt,
              }
            : undefined;
        this.link = data.link || '';
        this.urlPattern = data.urlPattern;
        this.closeAction = data.closeAction;
    }

    id: string;
    privacy?: BannerPrivacyEnum;
    whiteLabel?: string | undefined;
    displaySize?: BannerDisplaySizeEnum;
    desktopImage?: ContentImage;
    mobileImage?: ContentImage;
    link?: string;
    urlPattern?: string;
    closeAction?: TopBannerCloseActionEnum;

    toJSON() {
        return { ...this };
    }
}
